(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reset-buy-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reset-buy-bar')) {
    customElements.define(
      'reset-buy-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.watch = document.getElementById(this.dataset.watch || '');
          if (!this.watch || !('IntersectionObserver' in window)) return;

          this.mq = window.matchMedia('(max-width: 749px)');
          this.passed = false;
          this.blocked = new Set();
          this.raf = 0;

          this.observer = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                if (entry.target === this.watch) {
                  this.passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
                } else if (entry.isIntersecting) {
                  this.blocked.add(entry.target);
                } else {
                  this.blocked.delete(entry.target);
                }
              }
              this.update();
            },
            { threshold: 0 }
          );

          this.observer.observe(this.watch);
          const footer = document.querySelector('footer');
          if (footer) this.observer.observe(footer);
          document.querySelectorAll('[data-reset-buy]').forEach((element) => this.observer.observe(element));

          this.schedule = () => {
            if (this.raf) return;
            this.raf = window.requestAnimationFrame(() => {
              this.raf = 0;
              this.update();
            });
          };
          window.addEventListener('scroll', this.schedule, { passive: true });
          window.addEventListener('resize', this.schedule, { passive: true });
          this.mutation = new MutationObserver(this.schedule);
          this.mutation.observe(document.body, { childList: true });
        }

        cookieBannerVisible() {
          const banner = document.querySelector(
            '#consentmo-banner, .consentmo-banner, [id*="cookie" i][id*="banner" i], [class*="cookie" i][class*="banner" i], [id*="consent" i][id*="banner" i], [class*="consent" i][class*="banner" i], [id*="cookie" i][id*="popup" i], .cc-window'
          );
          if (!banner) return false;
          const rect = banner.getBoundingClientRect();
          return (
            rect.height > 0 &&
            rect.bottom > 0 &&
            rect.top < window.innerHeight &&
            getComputedStyle(banner).visibility !== 'hidden'
          );
        }

        update() {
          const show = this.mq.matches && this.passed && this.blocked.size === 0 && !this.cookieBannerVisible();
          this.hidden = !show;
          document.body.classList.toggle('reset-buy-bar-open', show);
        }

        disconnectedCallback() {
          document.body.classList.remove('reset-buy-bar-open');
          this.observer?.disconnect();
          this.mutation?.disconnect();
          window.removeEventListener('scroll', this.schedule);
          window.removeEventListener('resize', this.schedule);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reset-digital-consent-global"] && !Shopify.designMode) return;
  try {
    (() => {
    const ATTRIBUTE_KEY = 'Consenso contenuto digitale';
    const CONSENT_TEXT =
      'Chiedo che la fornitura del contenuto digitale inizi immediatamente e riconosco che, con l’inizio dell’esecuzione, perderò il diritto di recesso nei casi previsti dalla legge.';
    const ROOT = window.Shopify?.routes?.root || '/';
    // Fix 6: the cart summary is re-rendered after a one-tap package swap. The consent
    // saved in this page session is restored so the customer does not tick twice.
    let lastSavedValue = '';

    const getCheckoutButton = (ctas) =>
      ctas?.querySelector('#checkout, button[name="checkout"], input[name="checkout"]');

    const setCheckoutLocked = (ctas, locked) => {
      const checkout = getCheckoutButton(ctas);
      if (!checkout) return;

      if (!checkout.dataset.resetConsentInitialDisabled) {
        checkout.dataset.resetConsentInitialDisabled = checkout.disabled ? 'true' : 'false';
      }

      const initiallyDisabled = checkout.dataset.resetConsentInitialDisabled === 'true';
      checkout.disabled = initiallyDisabled || locked;
      checkout.dataset.resetConsentLocked = locked ? 'true' : 'false';
    };

    const createConsent = (ctas, index) => {
      const wrapper = document.createElement('div');
      const checkboxId = `reset-digital-consent-${index}-${Math.random().toString(36).slice(2, 8)}`;

      wrapper.className = 'reset-digital-consent';
      wrapper.dataset.resetConsentSaved = 'false';
      wrapper.innerHTML = `
        <div class="reset-digital-consent__field">
          <input
            class="reset-digital-consent__checkbox"
            type="checkbox"
            id="${checkboxId}"
            aria-required="true"
            autocomplete="off"
          >
          <label class="reset-digital-consent__label" for="${checkboxId}">${CONSENT_TEXT}</label>
        </div>
        <p class="reset-digital-consent__help">Casella obbligatoria per procedere al pagamento.</p>
        <p class="reset-digital-consent__status" aria-live="polite" hidden></p>
      `;

      if (lastSavedValue) {
        const restoredCheckbox = wrapper.querySelector('.reset-digital-consent__checkbox');
        const restoredStatus = wrapper.querySelector('.reset-digital-consent__status');
        if (restoredCheckbox) restoredCheckbox.checked = true;
        wrapper.dataset.resetConsentSaved = 'true';
        if (restoredStatus) {
          restoredStatus.hidden = false;
          restoredStatus.textContent = 'Consenso registrato. Puoi procedere al pagamento.';
        }
      }

      ctas.before(wrapper);
      setCheckoutLocked(ctas, true);
      return wrapper;
    };

    const syncConsent = (ctas, wrapper) => {
      const checkbox = wrapper?.querySelector('.reset-digital-consent__checkbox');
      const saved = wrapper?.dataset.resetConsentSaved === 'true';
      setCheckoutLocked(ctas, !(checkbox?.checked && saved));
    };

    const installConsent = () => {
      document.querySelectorAll('.cart__ctas').forEach((ctas, index) => {
        let wrapper = ctas.previousElementSibling;
        if (!wrapper?.classList.contains('reset-digital-consent')) {
          wrapper = createConsent(ctas, index);
        }
        syncConsent(ctas, wrapper);
      });
    };

    const updateCartAttribute = async (value) => {
      const response = await fetch(`${ROOT}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [ATTRIBUTE_KEY]: value,
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`Cart attribute update failed: ${response.status}`);
      }

      return response.json();
    };

    document.addEventListener('change', async (event) => {
      const checkbox = event.target instanceof Element
        ? event.target.closest('.reset-digital-consent__checkbox')
        : null;
      if (!checkbox) return;

      const wrapper = checkbox.closest('.reset-digital-consent');
      const ctas = wrapper?.nextElementSibling?.classList.contains('cart__ctas')
        ? wrapper.nextElementSibling
        : null;
      const status = wrapper?.querySelector('.reset-digital-consent__status');
      if (!wrapper || !ctas || !status) return;

      wrapper.dataset.resetConsentSaved = 'false';
      setCheckoutLocked(ctas, true);
      status.hidden = false;
      status.classList.remove('reset-digital-consent__status--error');

      if (!checkbox.checked) {
        lastSavedValue = '';
        status.textContent = 'Consenso non confermato.';
        try {
          await updateCartAttribute('');
        } catch (error) {
          console.error(error);
        }
        return;
      }

      status.textContent = 'Salvataggio del consenso…';

      const timestamp = new Date().toISOString();
      const value = `Sì — fornitura immediata richiesta e perdita del diritto di recesso riconosciuta — ${timestamp}`;

      try {
        await updateCartAttribute(value);
        if (!checkbox.checked) return;

        lastSavedValue = value;
        wrapper.dataset.resetConsentSaved = 'true';
        status.textContent = 'Consenso registrato. Puoi procedere al pagamento.';
        setCheckoutLocked(ctas, false);
      } catch (error) {
        console.error(error);
        checkbox.checked = false;
        wrapper.dataset.resetConsentSaved = 'false';
        status.textContent = 'Non è stato possibile registrare il consenso. Riprova.';
        status.classList.add('reset-digital-consent__status--error');
        setCheckoutLocked(ctas, true);
      }
    });

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const checkout = target?.closest('#checkout, button[name="checkout"], input[name="checkout"]');
        if (!checkout) return;

        const ctas = checkout.closest('.cart__ctas');
        const wrapper = ctas?.previousElementSibling?.classList.contains('reset-digital-consent')
          ? ctas.previousElementSibling
          : null;
        const checkbox = wrapper?.querySelector('.reset-digital-consent__checkbox');
        const saved = wrapper?.dataset.resetConsentSaved === 'true';

        if (!checkbox?.checked || !saved) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          checkbox?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          checkbox?.focus({ preventScroll: true });
        }
      },
      true
    );

    let scheduled = false;
    const scheduleInstall = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        installConsent();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', installConsent, { once: true });
    } else {
      installConsent();
    }

    new MutationObserver(scheduleInstall).observe(document.body, {
      childList: true,
      subtree: true,
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reset-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reset-review-slider')) {
    customElements.define(
      'reset-review-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('.reset-trust__list');
          this.dots = this.querySelector('.reset-trust__dots');
          if (!this.list) return;
          this.cards = Array.from(this.list.children);
          if (this.dots) {
            this.dots.innerHTML = this.cards.map(() => '<span></span>').join('');
          }
          const wrapper = this.closest('.reset-trust__quotes');
          wrapper?.querySelectorAll('[data-reset-slide]').forEach((button) => {
            button.addEventListener('click', () => this.step(Number(button.dataset.resetSlide)));
          });
          this.list.addEventListener('scroll', () => this.updateDots(), { passive: true });
          this.updateDots();
        }

        step(direction) {
          const card = this.cards[0];
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.list).columnGap || getComputedStyle(this.list).gap) || 16;
          this.list.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
        }

        updateDots() {
          if (!this.dots || !this.cards.length) return;
          const card = this.cards[0];
          const gap = parseFloat(getComputedStyle(this.list).columnGap || getComputedStyle(this.list).gap) || 16;
          const index = Math.round(this.list.scrollLeft / (card.offsetWidth + gap));
          Array.from(this.dots.children).forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
